<template>
  <b-modal id="confirmDepartmentDelete"  ref="confirmDepartmentDelete" no-stacking>
    <template slot="modal-title">{{ $t('confirmationTitle') }}</template>
    <p>{{ $t('confirmDeleteDepartment') }}</p>
    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" @click="deleteOrganization">{{ $t('delete') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="cancel">{{ $t('cancel') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
  import OrganizationService from '../../services/OrganizationService'

  export default {
    name: "DeleteDepartmentModal",
    methods: {
      deleteOrganization () {
        OrganizationService.deleteDepartment(this.$route.params.departmentId)
          .then(() => {
            this.$router.push('/organizations/' + this.$route.params.id)
          })
      },
      cancel () {
        this.$bvModal.hide('confirmDepartmentDelete')
      }
    },
    i18n: {
      messages: {
        en: {
          'confirmationTitle': 'Confirmation',
          'confirmDeleteDepartment': 'Are you sure you want to delete the department?',
          'delete': 'Delete',
          'cancel': 'Cancel'
        },
        nb: {
          'confirmationTitle': 'Bekreftelse',
          'confirmDeleteDepartment': 'Er du sikker på at du vil slette avdelingen?',
          'delete': 'Slett',
          'cancel': 'Avbryt'
        }
      }
    }
  }
</script>